class QuoteSlider {
  constructor(selector, options) {
    this.selector = selector;
    this.heightMap = {};
    this.splide = new Splide(selector, options);
    this.paginationInfoContainer = document.querySelector('.quote-slider-section .js-pagination-info');

    this.updatePageInfo = this.updatePageInfo.bind(this);
  }

  init() {
    this.splide.on("mounted", (e) => this.onMountedHeightUpdate(e));
    this.splide.on("active", (e) => this.onActiveHeightUpdate(e));
    this.splide.mount();
    this.splide.on('moved', this.updatePageInfo);
    this.updatePageInfo();
    this.insertSection();
  }

  onMountedHeightUpdate() {
    let i = 0;
    this.splide.root.querySelectorAll(".splide__slide").forEach((e) => {
      if (!e.classList.contains('splide__slide--clone')) {
        this.heightMap[i] = e.scrollHeight;
        i++
      }
    });
  }

  onActiveHeightUpdate(data) {
    const maxHeight = this.heightMap[data.slideIndex] + "px";
    data.slide.style.maxHeight = maxHeight;
    data.slide.parentElement.style.maxHeight = maxHeight;
  }


  updatePageInfo() {
    const totalItems = this.splide.length;
    const itemsPerPage = this.splide.options.perPage;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const currentPage = Math.ceil((this.splide.index + 1) / itemsPerPage);

    this.paginationInfoContainer.textContent = `${currentPage} / ${totalPages}`;
  }

  insertSection() {
    const sectionToMove = document.querySelector(this.selector).parentNode.parentNode.parentNode;
    const insertTarget = document.querySelector(this.selector).parentNode.parentNode.getAttribute('data-insert');
    if (insertTarget) {
      const insertTargetNode = document.querySelector(insertTarget);
      insertTargetNode.parentNode.insertBefore(sectionToMove, insertTargetNode);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const splideQuoteSlider = new QuoteSlider('#slider-quote-slider-quotes', {
    type: 'loop',
    perPage: 1,
    rewind: true,
    pagination: true,
    autoHeight: true,
    breakpoints: {
      768: {
        perPage: 1,
      },
    }
  });

  splideQuoteSlider.init();
});
